import { useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTES } from "@constants";
import SharedLayout from "@/layouts/SharedLayout/SharedLayout";
// import LoadingScreen from "@components/LoadingScreen/LoadingScreen";
import LoadingScreenNew from "@components/LoadingScreen/LoadingScreenNew";

// Pages
import TongQuanPage from "@pages/TongQuanPage";
import MatBangPage from "@pages/MatBangPage";
import TienIchPage from "@pages/TienIchPage";
import GalleryPage from "@pages/GalleryPage";
import BrochurePage from "@pages/BrochurePage";
import NotFoundPage from "@pages/NotFoundPage";
// import DevFloorPlanEditor from "@pages/DevFloorPlanEditor/DevFloorPlanEditor";

function App() {
  const [isAppLoading, setIsAppLoading] = useState(true);

  return (
    <>
      {isAppLoading && (
        <LoadingScreenNew onFinished={() => setIsAppLoading(false)} />
      )}
      <HashRouter basename={import.meta.env.BASE_URL}>
        <Routes>
          {/* Layout route — SharedLayout bao toàn bộ các trang con */}
          <Route element={<SharedLayout />}>
            <Route path={ROUTES.HOME} element={<TongQuanPage />} />
            <Route path={ROUTES.MAT_BANG} element={<MatBangPage />} />
            <Route path={ROUTES.TIEN_ICH} element={<TienIchPage />} />
            <Route path={ROUTES.GALLERY} element={<GalleryPage />} />
            <Route path={ROUTES.BROCHURE} element={<BrochurePage />} />
          </Route>

          {/* Developer Tool — ngoài layout */}
          {/* <Route path="/dev/floorplan-editor" element={<DevFloorPlanEditor />} /> */}

          {/* 404 — ngoài layout, không có Navbar */}
          <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
